import routes from './routes.autogen';
import NotFound from './p/NotFound';
import ReoutBase from './reout-base';

class ReoutFull extends ReoutBase {
	get_404_handler() {
		return NotFound;
	}

	get_routes() {
		return routes;
	}
}

const R = new ReoutFull();
const { A, BlessLink } = R;
export { R, A, BlessLink };



// WEBPACK FOOTER //
// ./src/routes.js